// extracted by mini-css-extract-plugin
export default {"form":"LGT9f","default":"gC8Yy","constant":"dklsM gC8Yy","variable":"C5POc gC8Yy","empty":"oD5Zr"};